/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/IDE-exercise/v0.ts
 */

import { createValidator } from '../../helpers/validator';
export var IDEExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    assignment: {
      type: 'string'
    },
    sample_code: {
      type: 'string',
      default: ''
    },
    instructions: {
      type: ['string', 'null'],
      default: null
    },
    pre_exercise_code: {
      type: 'string',
      default: ''
    },
    sct: {
      type: 'string',
      default: ''
    },
    solution: {
      type: 'string',
      default: ''
    },
    hint: {
      type: 'string'
    },
    language: {
      type: 'string',
      enum: ['r', 'python', 'revo', 'sql', 'shell', 'scala', 'julia', 'containers']
    },
    runtime_config: {
      type: 'string'
    },
    chapter_id: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    }
  },
  required: ['title', 'xp', 'assignment', 'sample_code', 'instructions', 'pre_exercise_code', 'sct', 'solution', 'hint', 'language', 'chapter_id', 'course_id'],
  definitions: {}
};
export var isValidIDEExerciseV0 = createValidator(IDEExerciseV0Schema);
export var IDEExerciseV0Definition = {
  schema: IDEExerciseV0Schema,
  validate: isValidIDEExerciseV0
};